import { render, staticRenderFns } from "./select-local-request.vue?vue&type=template&id=59aa24c6&scoped=true&"
import script from "./select-local-request.vue?vue&type=script&lang=js&"
export * from "./select-local-request.vue?vue&type=script&lang=js&"
import style0 from "./select-local-request.vue?vue&type=style&index=0&id=59aa24c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59aa24c6",
  null
  
)

export default component.exports